import React, { MouseEventHandler, useState } from 'react';
import Button from '@mui/material/Button';

import FormTextField from 'retired/FormTextField';

type CompanyValidationInputProps = {
  organizationName: string;
  onSubmit: MouseEventHandler;
  isFormValid: boolean;
};

export const CompanyValidationInput = ({
  organizationName,
  onSubmit,
  isFormValid,
}: CompanyValidationInputProps) => {
  const [paypalDeedFeesCompanyNameValidationInput, setPaypalDeedFeesCompanyNameValidationInput] =
    useState('');

  return (
    <>
      <FormTextField
        variant="standard"
        id="paypalDeedFeesCompanyInputValidation"
        inputProps={{ maxLength: 90 }}
        autoComplete="off"
        helperText="Validate change by typing company name"
        placeholder="e.g. Airbnb"
        style={{ width: 240, marginRight: 8 }}
        value={paypalDeedFeesCompanyNameValidationInput}
        onChange={(e) => setPaypalDeedFeesCompanyNameValidationInput(e.target.value)}
      />
      <Button
        variant="contained"
        disabled={paypalDeedFeesCompanyNameValidationInput !== organizationName || !isFormValid}
        onClick={(e) => {
          e.preventDefault();
          onSubmit(e);
        }}
      >
        Submit
      </Button>
    </>
  );
};
